<template>
  <div>
      <div class="row" v-if="!news.template_base_id">
          <div class="col-md-12">
              <div class="alert alert-danger text-center" role="alert">
                  Selecione um template para carregar o layout.
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-md-12">
                <div class="row" style="margin-bottom: 2em">
                    <div class="col-md-3">
                        <label>Titulo da campanha <span class="text-danger">*</span></label>
                        <input type="text" placeholder="Titulo da campanha..." class="form-control" v-model="news.title" required>
                    </div>
                    <div class="col-md-3">
                        <label>Template <span class="text-danger">*</span></label>
                        <select class="form-control" v-model="news.template_base_id" required readonly v-if="id_news">
                            <option value="">Selecione o template...</option>
                            <option v-for="template in templates" :value="template.id" :key="template.id">{{ template.title }}</option>
                        </select>
                        <select class="form-control" v-model="news.template_base_id" required v-else>
                            <option value="">Selecione o template...</option>
                            <option v-for="template in templates" :value="template.id" :key="template.id">{{ template.title }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label>Lista de e-mails <span class="text-danger">*</span></label>
                        <select multiple class="form-control" v-model="news.list" required>
                            <option value="">Selecione a lista...</option>
                            <option :value="list.id" :key="list.id" v-for="list in lists">{{ list.titulo }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label>Data e Hora do envio <span class="text-danger">*</span></label>
                        <input v-if="schedule" type="datetime-local" placeholder="Data e hora de envio" class="form-control" v-model="news.send_date" required readonly>
                        <input v-else type="datetime-local" placeholder="Data e hora de envio" class="form-control" v-model="news.send_date" required>
                        <span class="text-danger" v-if="schedule">* Agendamento confirmado, alteração indisponível.</span>
                    </div>
                </div>
              <CLayout1 v-if="news.template_base_id === 1" :id_news="id_news" :list="this.news.list" :title="this.news.title" :send_date="this.news.send_date" :templateId="this.news.template_base_id" :templateNews="this.news.template"/>
              <CLayout2 v-if="news.template_base_id === 2" :id_news="id_news" :list="this.news.list" :title="this.news.title" :send_date="this.news.send_date" :templateId="this.news.template_base_id" :templateNews="this.news.template"/>
          </div>
      </div>
  </div>
</template>

<script>

import CLayout1 from './layouts/layout-1/layout-1.vue'
import CLayout2 from './layouts/layout-2/layout-2.vue'
import axios from "axios";

export default {
    name: 'MailEditor',
    components: { CLayout1, CLayout2 },
    props: ['id_news', 'schedule'],
    data() {
        return {
            templates: [],
            lists: [],
            title: '',
            news: {
                title: '',
                template: '',
                template_base_id: '',
                list: [],
                send_date: ''
            },
            appRoot: _ROOT_PATH
        }    
    },
    beforeMount() {
        var _this = this;

        axios.get(_ROOT_PATH + '/admin/news-atlas/buscar-templates')
            .then(function (response) {
                _this.templates = response.data;
            }).catch(function (error) {
            console.error(error);
        });

        axios.get(_ROOT_PATH + '/admin/news-atlas/buscar-listas')
            .then(function (response) {
                _this.lists = response.data;
            }).catch(function (error) {
            console.error(error);
        });

        if (this.id_news) {
            axios.get(_ROOT_PATH + '/admin/news-atlas/buscar-cadastro/' + this.id_news)
                .then(function (response) {
                    _this.news.title            = response.data.title;
                    _this.news.template         = response.data.template;
                    _this.news.template_base_id = response.data.template_base_id;
                    _this.news.send_date        = response.data.send_date;

                    var list_news = response.data.list;
                    for (var i = 0; i < list_news.length; i++) {
                        _this.news.list.push(list_news[i].list_id);
                    }

                }).catch(function (error) {
                console.error(error);
            });
        }

    },
}
</script>

<style lang="scss" scoped>
</style>